import React from 'react'

import FooterNavigation from 'Components/Blocks/Footer/Navigation'
import FooterSocials from 'Components/Blocks/Footer/Socials'
import { Column, Row } from 'Components/UI'

import { LANDING_INLINE_PADDINGS } from 'Constants/Landing'

import { useResponsiveLayout } from 'Hooks'

import FooterContacts from './Contact'
import FooterCopyrights from './Copyrights'
import { Container, Content } from './styles'

function Footer() {
  const { isMobile, isTablet } = useResponsiveLayout()

  return (
    <Container pt={LANDING_INLINE_PADDINGS} px={LANDING_INLINE_PADDINGS}>
      <Content>
        {isMobile || isTablet ? (
          <Column gap={11} mb={7}>
            <FooterContacts />

            <FooterNavigation />

            <FooterSocials />
          </Column>
        ) : (
          <Row fullWidth gap={11} mb={11} spaceBetween>
            <FooterContacts />

            <Column gap={11} my={7}>
              <FooterNavigation />

              <FooterSocials />
            </Column>
          </Row>
        )}

        <FooterCopyrights />
      </Content>
    </Container>
  )
}

export default Footer
